<template>
  <div class="vx-row match-height">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <vs-tab :label="$t('InventoryReserve')" class="mt-2">
            <Reserves></Reserves>
          </vs-tab>
          <vs-tab :label="$t('InventoryRecharge')" class="mt-2">
            <Recharges></Recharges>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import Reserves from "./Reserves.vue";
import Recharges from "./Recharges.vue";
export default {
  name: "warehouseManagement_invwetoryReservations_Index",
  components: {
    Reserves,
    Recharges,
  },
};
</script>
